<template>
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 174.9 161.1"
    style="enable-background:new 0 0 174.9 161.1;"
  >
    <g v-if="logoStyle === 'normal'">
      <rect x="20.5" y="17.5" class="st0" width="133" height="128" />
      <linearGradient
        id="compromisGradient"
        gradientUnits="userSpaceOnUse"
        x1="130.2228"
        y1="-16.8658"
        x2="47.7087"
        y2="170.8646"
      >
        <stop offset="0" style="stop-color: #F29027" />
        <stop offset="0.2356" style="stop-color: #EC8027" />
        <stop offset="0.6924" style="stop-color: #DD5727" />
        <stop offset="1" style="stop-color: #D13827" />
      </linearGradient>
      <path
        class="st1"
        d="M150.5,0.3H24.5c-9.4,0-17,7.6-17,17v126.1c0,9.4,7.6,17,17,17h126.1c9.4,0,17-7.6,17-17V17.3
        C167.5,7.9,159.9,0.3,150.5,0.3z M102.5,46h17.8v17h-17.8V46z M47.6,46.7c3.1,6.3,6.8,7.8,13.1,7.8V46h17.8v17H62
        c-10.2,0-16.9-2.5-21.3-12.4L47.6,46.7z M87.5,122.7c-22.3,0-40.6-6.9-56.7-20.3l6.2-7.9c16,11.4,29.1,16.6,50.5,16.6
        c21.4,0,34.5-5.2,50.5-16.6l6.2,7.9C128.1,115.8,109.9,122.7,87.5,122.7z"
      />
    </g>
    <g v-if="logoStyle === 'mono' || logoStyle === 'dol'">
      <rect v-if="logoStyle === 'dol'" x="20.5" y="17.5" class="st0" width="133" height="128" />
      <path
        fill="currentColor"
        d="M150.5,0.3H24.5c-9.4,0-17,7.6-17,17v126.1c0,9.4,7.6,17,17,17h126.1c9.4,0,17-7.6,17-17V17.3
        C167.5,7.9,159.9,0.3,150.5,0.3z M102.5,46h17.8v17h-17.8V46z M47.6,46.7c3.1,6.3,6.8,7.8,13.1,7.8V46h17.8v17H62
        c-10.2,0-16.9-2.5-21.3-12.4L47.6,46.7z M87.5,122.7c-22.3,0-40.6-6.9-56.7-20.3l6.2-7.9c16,11.4,29.1,16.6,50.5,16.6
        c21.4,0,34.5-5.2,50.5-16.6l6.2,7.9C128.1,115.8,109.9,122.7,87.5,122.7z"
      />
    </g>
    <g v-if="logoStyle === 'feminista'">
      <rect x="20.5" y="18.2" class="st0" width="133" height="128" />
      <linearGradient
        id="feministaGradient"
        gradientUnits="userSpaceOnUse"
        x1="130.2228"
        y1="-16.1476"
        x2="47.7087"
        y2="171.5828"
      >
        <stop offset="0" style="stop-color: #C44486" />
        <stop offset="1" style="stop-color: #7D3980" />
      </linearGradient>
      <path
        class="st2"
        d="M150.5,1H24.5c-9.4,0-17,7.6-17,17v126.1c0,9.4,7.6,17,17,17h126.1c9.4,0,17-7.6,17-17V18
          C167.5,8.6,159.9,1,150.5,1z M102.5,46.7h17.8v17h-17.8V46.7z M47.6,47.4c3.1,6.3,6.8,7.8,13.1,7.8v-8.4h17.8v17H62
          c-10.2,0-16.9-2.5-21.3-12.4L47.6,47.4z M87.5,123.4c-22.3,0-40.6-6.9-56.7-20.3l6.2-7.9c16,11.4,29.1,16.6,50.5,16.6
          c21.4,0,34.5-5.2,50.5-16.6l6.2,7.9C128.1,116.5,109.9,123.4,87.5,123.4z"
      />
    </g>
    <g v-if="logoStyle === 'lgtb'">
      <rect x="20.5" y="17.5" class="st0" width="133" height="128" />
      <g>
        <defs>
          <path
            id="SVGID_3_"
            d="M150.5,0.3H24.5c-9.4,0-17,7.6-17,17v126.1c0,9.4,7.6,17,17,17h126.1c9.4,0,17-7.6,17-17V17.3
              C167.5,7.9,159.9,0.3,150.5,0.3z M102.5,46h17.8v17h-17.8V46z M47.6,46.7c3.1,6.3,6.8,7.8,13.1,7.8V46h17.8v17H62
              c-10.2,0-16.9-2.5-21.3-12.4L47.6,46.7z M87.5,122.7c-22.3,0-40.6-6.9-56.7-20.3l6.2-7.9c16,11.4,29.1,16.6,50.5,16.6
              c21.4,0,34.5-5.2,50.5-16.6l6.2,7.9C128.1,115.8,109.9,122.7,87.5,122.7z"
          />
        </defs>
        <clipPath id="SVGID_4_">
          <use xlink:href="#SVGID_3_" style="overflow:visible;" />
        </clipPath>
        <g class="st3">
          <rect class="st4" width="174.9" height="26.8" />
          <rect y="26.8" class="st5" width="174.9" height="26.8" />
          <rect y="53.6" class="st6" width="174.9" height="26.8" />
          <rect y="80.4" class="st7" width="174.9" height="26.8" />
          <rect y="107.2" class="st8" width="174.9" height="26.8" />
          <rect y="133.9" class="st9" width="174.9" height="26.8" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'careta',

  props: {
    logoStyle: {
      type: String,
      default: 'normal',
      validator: (value) => {
        return ['mono', 'normal', 'feminista', 'lgtb', 'dol'].includes(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .st0 { fill: #FFFFFF; }
  .st1 { fill: url(#compromisGradient); }
  .st2 { fill: url(#feministaGradient); }
  .st3 { clip-path:url(#SVGID_4_); }
  .st4 { fill: #EF404D; }
  .st5 { fill: #F79226; }
  .st6 { fill: #FFD10F; }
  .st7 { fill: #7FC347; }
  .st8 { fill: #55A4DB; }
  .st9 { fill: #A14A9C; }
  .st10 { fill:url(#SVGID_5_); }
  .st11 { fill:url(#SVGID_6_); }
  .st12 { clip-path:url(#SVGID_8_); }
</style>
